import classNames from "classnames";
import { Field, withFormik } from "formik";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import Button from "pages/_components/Button";
import Container from "pages/_components/Container";
import GeneralMsg from "pages/_components/GeneralMsg";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import Spinner from "pages/_components/Spinner";
import TabletSelectors from "pages/_components/TabletSelectors";
import DrawerModal from "pages/_components/drawer/DrawerModal";
import Hint from "pages/_components/hints/Hint";
import Pagination from "pages/_components/pagination/Pagination";
import CedipCard from "pages/cedip/_components/CedipCard";
import Productselector from "pages/forms/_components/_fields/Productselector";
import { array, bool, func, oneOfType, shape, string } from "prop-types";
import React, { useCallback, useEffect, useMemo, useState } from "react";
// eslint-disable-next-line import/no-unresolved
import { Button as UiButton } from "@ui-kit/components/index.es";
import { Col } from "react-bootstrap";
import { isIOS } from "react-device-detect";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as cedipActions, selectors as cedipSelectors } from "reducers/cedip";
import { selectors as sessionSelectors } from "reducers/session";
import { compose } from "redux";
import * as configUtils from "util/config";
import { getLimitDate } from "util/date";
import * as i18n from "util/i18n";
import Yup from "yup";
import { useEmbeddedV3ShellLayoutSync, isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { V3_SCROLL_ROOT_ID } from "v3/constants";
import { resizableRoute } from "pages/_components/Resizable";
import CedipFilters from "./_components/CedipFilters";

const FORM_ID = "deposits.cedip";
const INIT_CEDIP_STATE = {
    filterOrder: {
        column: "",
        direction: "",
    },
    cleanFilter: false,
    showCleanFilterButton: false,
    showDrawer: false,
    cedipToAccept: {},
    cedips: {},
    cedipsList: {},
};

function CedipList(props) {
    const {
        accounts,
        user,
        dispatch,
        match,
        filters,
        cedips,
        cedipsPageNumber,
        cedipsTotalPages,
        fetching,
        fetchingDownload,
        isDesktop,
        isSmallDesktop,
        values,
        recievedCedipSelected,
        ownCedipSelected,
        setValues,
        showForm,
        setErrors,
        activeEnvironment,
        filtersReceived,
        hasMoreData,
        embeddedInV3Shell,
    } = props;

    const [cedipState, setCedipState] = useState(INIT_CEDIP_STATE);

    const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
    const enableNewPagination = configUtils.getBoolean("frontend.show.nuevoComponentePaginado.enabled", false);
    const maxBoxDisplay = configUtils.getInteger("product.list.maxBoxDisplay", 5);
    const productAsCard = !enableNewPagination && cedips.length < maxBoxDisplay;

    const handleExport = useCallback(() => {
        const { orderColumName, orderDirection } = filters;
        const creationDateFromFormatted = moment(
            enableRangeDatefield ? values.creationDates[0] : values.creationDateFrom.toString().replace(".000Z", ""),
        ).format("YYYY-MM-DD");
        const creationDateToFormatted = moment(
            enableRangeDatefield ? values.creationDates[1] : values.creationDateTo.toString().replace(".000Z", ""),
        ).format("YYYY-MM-DD");
        const dueDateFromFormatted = moment(
            enableRangeDatefield ? values.dueDates[0] : values.dueDateFrom.toString().replace(".000Z", ""),
        ).format("YYYY-MM-DD");
        const dueDateToFormatted = moment(
            enableRangeDatefield ? values.dueDates[1] : values.dueDateTo.toString().replace(".000Z", ""),
        ).format("YYYY-MM-DD");

        const filter = {
            ...values,
            orderColumName,
            orderDirection,
            status: values.status,
            pageNumber: 1,
            creationDateFrom: creationDateFromFormatted,
            creationDateTo: creationDateToFormatted,
            dueDateFrom: dueDateFromFormatted,
            dueDateTo: dueDateToFormatted,
            format: "pdf",
            ...(enableRangeDatefield && {
                creationDate: values.creationDates.every((d) => d),
                dueDate: values.dueDates.every((d) => d),
            }),
        };

        dispatch(cedipActions.downloadList(filter));
    }, [dispatch, enableRangeDatefield, filters, values]);

    const renderCedipListToolbarRight = () => {
        if (isEmpty(cedips) && !activeEnvironment.permissions.cedip) {
            return <div />;
        }
        return (
            <UiButton
                aria-label={i18n.get("deposits.list.download")}
                className="icon-1-2"
                color="white"
                disabled={fetchingDownload}
                icon="SendDown"
                iconVariant="outline"
                loading={fetchingDownload}
                onClick={handleExport}
                variant="text"
            />
        );
    };

    const rightContentMobile = useMemo(() => {
        if (isDesktop) {
            return undefined;
        }
        if (isEmpty(cedips) && !activeEnvironment.permissions.cedip) {
            return <div />;
        }
        return (
            <UiButton
                aria-label={i18n.get("deposits.list.download")}
                color="white"
                isInactive={fetchingDownload}
                icon="SendDown"
                iconVariant="outline"
                loading={fetchingDownload}
                onClick={handleExport}
                variant="text"
            />
        );
    }, [isDesktop, cedips, activeEnvironment.permissions.cedip, fetchingDownload, handleExport]);

    useEmbeddedV3ShellLayoutSync(dispatch, {
        embeddedInV3Shell,
        isDesktop,
        titleKey: "menu.investments.manageCedip",
        goBackPath: "/v3/dashboard",
        scopes: ["cedip"],
        rightContentMobile,
    });
    const cedipInformationBox = configUtils.get("frontend.cedip.information.text");
    const setShowForm = (showFormProp) => dispatch(cedipActions.setShowForm(showFormProp));

    useEffect(() => {
        if (!fetching && !cedips.length && isIOS) {
            window.scrollTo(0, 1);
        }
    }, [fetching, cedips.length]);

    useEffect(() => {
        const filtersActive = ownCedipSelected ? filters : filtersReceived;
        let cedipFilters = {
            ...filtersActive,
            ...values,
            creationDateFrom: filtersActive?.creationDateFrom || values?.creationDateFrom,
            creationDateTo: filtersActive?.creationDateTo || values?.creationDateTo,
            creationDates: filtersActive?.creationDates || values?.creationDates,
            dueDateFrom: filtersActive?.dueDateFrom || values?.dueDateFrom,
            dueDateTo: filtersActive?.dueDateTo || values?.dueDateTo,
            dueDates: filtersActive?.dueDates || values?.dueDates,
            filterActivated: filtersActive?.filterActivated || false,
            pageNumber: 1,
            idCedip: match?.params?.cedipId || filtersActive?.idCedip,
        };

        setValues({ ...cedipFilters });
        cedipFilters = {
            ...cedipFilters,
            ...(enableRangeDatefield && {
                creationDate: cedipFilters.creationDates.every((d) => d),
                dueDate: cedipFilters.dueDates.every((d) => d),
            }),
        };
        if (ownCedipSelected) {
            dispatch(cedipActions.setFilters(cedipFilters));
        } else {
            dispatch(cedipActions.setFiltersReceived(cedipFilters));
        }

        setCedipState({
            ...cedipState,
            ...values,
            showCleanFilterButton: cedipFilters?.filterActivated,
        });
        dispatch(accountsActions.listAccounts(user.userId));
        dispatch(cedipActions.listCedip(cedipFilters, isDesktop, true));

        if (isDesktop) {
            setShowForm(false);
        }
        // eslint-disable-next-line
    }, [match, dispatch, isDesktop]);

    const { showCleanFilterButton } = cedipState;

    const isDateChanged = (date1, date2) => {
        const dateOne = date1 && date1 instanceof moment ? date1.toDate() : date1;
        const dateTwo = date2 && date2 instanceof moment ? date2.toDate() : date2;
        return dateOne?.toDateString() !== dateTwo?.toDateString();
    };

    const handleSubmitFilters = () => {
        if (!isDesktop) {
            dispatch(cedipActions.cleanCedips());
        }
        const {
            creationDate,
            creationDates: [creationDateFromRDP, creationDateToRDP],
            creationDateFrom,
            creationDateTo,
            dueDate,
            dueDates: [dueDateFromRDP, dueDateToRDP],
            dueDateFrom,
            dueDateTo,
            idCedip,
            orderColumName,
            orderDirection,
            status,
        } = values;
        const creationDateFromChanged = isDateChanged(
            enableRangeDatefield ? creationDateFromRDP : creationDateFrom,
            getLimitDate(-30),
        );
        const creationDateToChanged = isDateChanged(
            enableRangeDatefield ? creationDateToRDP : creationDateTo,
            getLimitDate(0),
        );
        const duenDateFromChanged = isDateChanged(enableRangeDatefield ? dueDateFromRDP : dueDateFrom, getLimitDate(0));
        const dueDateToChanged = isDateChanged(enableRangeDatefield ? dueDateToRDP : dueDateTo, getLimitDate(30));
        const idCedipEmpty = !idCedip;
        if (
            !(
                (recievedCedipSelected && status === "ACTIVO-PENDIENTE") ||
                (!recievedCedipSelected && status === "ACTIVO")
            ) ||
            !idCedipEmpty ||
            !creationDate ||
            !dueDate ||
            creationDateFromChanged ||
            creationDateToChanged ||
            duenDateFromChanged ||
            dueDateToChanged ||
            orderColumName !== "fecha_vencimiento" ||
            orderDirection !== "descendent"
        ) {
            setCedipState({
                ...cedipState,
                ...values,
                showCleanFilterButton: true,
            });
            if (ownCedipSelected) {
                dispatch(
                    cedipActions.setFilters({
                        ...filters,
                        filterActivated: true,
                        pageNumber: 1,
                    }),
                );
            } else {
                dispatch(
                    cedipActions.setFiltersReceived({
                        ...filtersReceived,
                        filterActivated: true,
                        pageNumber: 1,
                    }),
                );
            }
        } else {
            setCedipState({
                ...cedipState,
                ...values,
                showCleanFilterButton: false,
            });
        }
    };

    const handleChangeDirection = ({ newColumn: direction }) => {
        setCedipState((prevState) => ({
            ...prevState,
            filterOrder: {
                ...prevState.filterOrder,
                direction,
            },
            directionFilter: direction,
        }));
        setValues({ ...values, orderDirection: direction });
        if (ownCedipSelected) {
            dispatch(
                cedipActions.setFilters({
                    ...filters,
                    filterActivated: true,
                }),
            );
        } else {
            dispatch(
                cedipActions.setFiltersReceived({
                    ...filtersReceived,
                    filterActivated: true,
                }),
            );
        }
    };
    const setDefaultDate = (filtersCedip) => {
        const hasCreationDate = enableRangeDatefield && filtersCedip?.creationDates?.length > 0;
        const hasDueDate = enableRangeDatefield && filtersCedip?.dueDates?.length > 0;
        return {
            ...filtersCedip,
            creationDateFrom: hasCreationDate
                ? filtersCedip.creationDates[0]
                : filtersCedip?.creationDateFrom || getLimitDate(-30),
            creationDateTo: hasCreationDate
                ? filtersCedip.creationDates[1]
                : filtersCedip?.creationDateTo || getLimitDate(0),
            creationDates: filtersCedip?.creationDates || [getLimitDate(-30).toDate(), getLimitDate(0).toDate()],
            dueDateFrom: hasDueDate ? filtersCedip.dueDates[0] : filtersCedip?.dueDateFrom || getLimitDate(0),
            dueDateTo: hasDueDate ? filtersCedip.dueDates[1] : filtersCedip?.dueDateTo || getLimitDate(30),
            dueDates: filtersCedip?.dueDates || [getLimitDate(0).toDate(), getLimitDate(30).toDate()],
        };
    };

    const handleChangeButton = (button) => {
        if ((button === "myCedip" && ownCedipSelected) || (button === "recieved" && recievedCedipSelected)) {
            return false;
        }
        setErrors({});
        dispatch(cedipActions.cleanCedips());
        let filterSet;

        if (button === "myCedip") {
            dispatch(cedipActions.setOwnCedipSelected());
            filterSet = setDefaultDate(filters);
            filterSet = { ...filterSet, pageNumber: 1 };
            setValues({ ...filterSet });
            dispatch(cedipActions.setFilters(filterSet));
        } else {
            dispatch(cedipActions.setRecievedCedipSelected());
            filterSet = setDefaultDate(filtersReceived);
            filterSet = { ...filterSet, pageNumber: 1 };
            setValues({ ...filterSet });
            dispatch(cedipActions.setFiltersReceived(filterSet));
        }
        setCedipState((prevState) => ({
            ...prevState,
            filterOrder: {
                column: filterSet?.orderColumName,
                direction: filterSet?.orderDirection,
            },
            filterSelected: filterSet?.orderColumName,
            directionFilter: filterSet?.orderDirection,
            showCleanFilterButton: filterSet?.filterActivated,
        }));
        dispatch(cedipActions.listCedip(filterSet, isDesktop, true));
        return null;
    };

    const handleChangeOrderBy = ({ newDirection: orderBy }) => {
        setCedipState((prevState) => ({
            ...prevState,
            filterOrder: {
                ...prevState.filterOrder,
                column: orderBy,
            },
            filterSelected: orderBy,
        }));
        setValues({ ...values, orderColumName: orderBy });
        if (ownCedipSelected) {
            dispatch(
                cedipActions.setFilters({
                    ...filters,
                    filterActivated: true,
                }),
            );
        } else {
            dispatch(
                cedipActions.setFiltersReceived({
                    ...filtersReceived,
                    filterActivated: true,
                }),
            );
        }
    };

    const handleBack = () => (embeddedInV3Shell ? dispatch(push("/v3/dashboard")) : dispatch(push("/desktop/")));

    const cleanFilters = () => {
        const newValues = {
            status: recievedCedipSelected ? "ACTIVO-PENDIENTE" : "ACTIVO",
            idCedip: "",
            creationDate: true,
            creationDateFrom: getLimitDate(-30),
            creationDateTo: getLimitDate(0),
            dueDate: true,
            dueDateFrom: getLimitDate(0),
            dueDateTo: getLimitDate(30),
            orderColumName: "fecha_vencimiento",
            orderDirection: "descendent",
            pageNumber: 1,
            filterActivated: false,
        };
        setCedipState((prevState) => ({
            ...prevState,
            filterOrder: {
                ...prevState.filterOrder,
                direction: "descendent",
            },
            cleanFilter: false,
            showCleanFilterButton: false,
            directionFilter: "descendent",
        }));
        setValues({
            ...newValues,
            ...(enableRangeDatefield && {
                creationDates: [newValues.creationDateFrom.toDate(), newValues.creationDateTo.toDate()],
                dueDates: [newValues.dueDateFrom.toDate(), newValues.dueDateTo.toDate()],
            }),
        });
        if (ownCedipSelected) {
            dispatch(cedipActions.setFilters(newValues));
        } else {
            dispatch(cedipActions.setFiltersReceived(newValues));
        }
        dispatch(cedipActions.cleanCedips());
        dispatch(cedipActions.listCedip(newValues, isDesktop, true));
    };

    const closeDrawer = () => {
        setCedipState({ ...cedipState, showDrawer: false });
    };

    const handleClickAccept = (cbu) => {
        const { cedipToAccept } = cedipState;
        dispatch(cedipActions.setSelectedCedip(cedipToAccept));
        dispatch(cedipActions.setAccepting(cbu));
        dispatch(push(`/cedip/accept`));
    };

    const renderHeader = () => (
        <div className="admin-detail-head px-0">
            {isDesktop && <Head onBack={handleBack} />}
            <Head
                title="menu.investments.manageCedip"
                onBack={!isDesktop ? handleBack : null}
                addButtonImageWhite={!isDesktop}
                titleClassName={!isDesktop ? "header-mobile-title-background-blue" : ""}
                headerClassName={!isDesktop && "blue-main-header-mobile blue-main-title-mobile"}
                hideMobileMenu={!isDesktop}
                rightContent={renderCedipListToolbarRight}
                imageStyle="mr-2"
                messageTooltip={isDesktop ? cedipInformationBox : undefined}
                hintText={isDesktop ? cedipInformationBox : undefined}
                alwaysShowMessage={isDesktop}
            />
        </div>
    );

    const renderDrawer = () => {
        const { cedipToAccept } = cedipState;
        const cedipCurrency = cedipToAccept?.codigoMoneda === "032" ? "0" : "2";
        const title = i18n.get(`${FORM_ID}.accept.modal.title`);

        const accountOptions = accounts
            .filter((item) => item.currency !== cedipCurrency)
            .sort((a, b) => b.favorite - a.favorite);

        const destinationAccount = values.account
            ? accountOptions.find(({ idProduct }) => idProduct === values.account)
            : "";

        const destinationCbuLabel = destinationAccount?.cbu
            ? i18n.get("deposits.cedip.accept.modal.destinationCbu", null, {
                  cbu: destinationAccount.cbu,
              })
            : "";

        return (
            <div className={classNames("h-100", { "mx-80": isDesktop, "mx-4": !isDesktop })}>
                {isDesktop && <h1 className="text-align-center margin-top-80">{title}</h1>}
                <div className="margin-top-80">
                    <Field
                        name="account"
                        component={Productselector}
                        idField="account"
                        data={{
                            emptyOptionLabel: "",
                            options: accountOptions,
                        }}
                        disabled={accounts.length === 0}
                        isRequired
                        mode="edit"
                        idForm={FORM_ID}
                        isDesktop={isDesktop}
                        customPlaceholder={i18n.get("transfers.productSelector.placeholder")}
                        controlLabelClassName="input__required"
                    />
                </div>

                {destinationAccount && <span>{destinationCbuLabel}</span>}
                <Col className="confirmation__content-button margin-top-80" lg={12} md={12} sm={12}>
                    <div className="admin-content-center">
                        <Button
                            image="images/arrowRight.svg"
                            imageStyle={isDesktop ? "mr-2" : "mr-1"}
                            bsStyle="primary"
                            label="global.continue"
                            disabled={!destinationAccount.cbu}
                            onClick={() => handleClickAccept(destinationAccount?.cbu)}
                        />
                    </div>
                </Col>
            </div>
        );
    };

    const getCedisNextPage = (nextPage) => {
        const filtersSelected = ownCedipSelected ? filters : filtersReceived;
        const cedipFilters = {
            ...values,
            pageNumber: nextPage || filtersSelected?.pageNumber + 1,
            filterActivated: filtersSelected?.filterActivated || false,
            ...(enableRangeDatefield && {
                creationDateFrom: values?.creationDates?.[0],
                creationDateTo: values?.creationDates?.[1],
                dueDateFrom: values?.dueDates?.[0],
                dueDateTo: values?.dueDates?.[1],
            }),
            ...(enableRangeDatefield && {
                creationDate: filtersSelected.creationDates.every((d) => d),
                dueDate: filtersSelected.dueDates.every((d) => d),
            }),
        };
        if (ownCedipSelected) {
            dispatch(cedipActions.setFilters(cedipFilters));
        } else {
            dispatch(cedipActions.setFiltersReceived(cedipFilters));
        }
        dispatch(cedipActions.listCedip(cedipFilters, isDesktop, false));
    };

    const endOfListItem = (
        <div className="table-row table-end mb-5" key="noMoreTransactions">
            <I18n id="deposits.list.finish.list" />
        </div>
    );
    return (
        <>
            {!embeddedInV3Shell && <Notification scopeToShow="cedip" notificationClassname="navbar-fixed-top" />}
            {!isDesktop && !embeddedInV3Shell && renderHeader()}
            {recievedCedipSelected && cedipState.showDrawer && (
                <DrawerModal
                    content={renderDrawer()}
                    width={isDesktop ? "560px" : "100vw"}
                    showDrawerRemote={cedipState.showDrawer}
                    isDesktop={isDesktop}
                    title={`${isDesktop ? "" : "deposits.cedip.accept.modal.header"}`}
                    headerContent={
                        !isDesktop && (
                            <div className="toolbar-item view-title align-self-center mx-0">
                                <I18n
                                    id="deposits.cedip.accept.modal.header"
                                    component="h1"
                                    componentProps={{
                                        className: "title-content header-mobile-title-background-blue mb-0",
                                    }}
                                />
                            </div>
                        )
                    }
                    drawerClassName="cedip-admit-drawer"
                    closeRemotely={() => closeDrawer()}
                />
            )}
            {isDesktop && renderHeader()}
            <div className="cedip__dashboard">
                <Container
                    className={classNames("align-items-center", { "py-3": isDesktop })}
                    rowClassName="align-items-center">
                    <Col xs={12} md={8} lg={10} className={classNames("container-white", { "py-3": isDesktop })}>
                        <div className={!isDesktop && "d-flex flex-column"}>
                            <TabletSelectors
                                allDisabled={fetching && !isDesktop}
                                isDesktop={isDesktop}
                                possibleOptions={[
                                    { value: "myCedip", label: `${FORM_ID}.myCedip` },
                                    { value: "recieved", label: `${FORM_ID}.recieved` },
                                ]}
                                changeOption={handleChangeButton}
                                optionSelected={recievedCedipSelected ? "recieved" : "myCedip"}
                                containerClass={classNames({
                                    "my-3": !isDesktop,
                                    "echeq-tablet-selectors": isDesktop,
                                })}
                                buttonContainerClass={classNames({
                                    "mx-0": !isDesktop,
                                    "m-0": isDesktop,
                                })}
                                buttonClass="align-self-flex-end m-0 px-45"
                                leftButtons
                            />
                        </div>
                    </Col>
                    {!isDesktop ? (
                        <Col xs={12} className="margin-left-auto align-items-end flex-column">
                            <Hint
                                classNameMessage=""
                                classNameGroup="justify-content-center d-flex my-3"
                                classNameImage="my-0 ml-2 justify-content-center align-self-center"
                                classNameHintP="aling-items-center my-2"
                                alwaysShowMessage
                                nodeMessage={
                                    <I18n
                                        defaultValue={cedipInformationBox}
                                        component="p"
                                        componentProps={{ className: "hint-text my-0" }}
                                    />
                                }
                            />
                        </Col>
                    ) : (
                        undefined
                    )}
                    <Col
                        xs={12}
                        md={4}
                        lg={2}
                        className={classNames("margin-left-auto align-items-end flex-column", {
                            "container-white py-4": isDesktop,
                        })}>
                        <Button
                            block
                            bsStyle="outline"
                            className="px-25 py-15 m-0 font-light right width-3 min-height-auto text-transform-none"
                            label={
                                showForm
                                    ? "global.hide.filter"
                                    : `${showCleanFilterButton ? "global.filter.active" : "global.see.filter"}`
                            }
                            onClick={() => setShowForm(!showForm)}
                            image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                        />
                        {showCleanFilterButton && (
                            <Button
                                label="global.clean.filters"
                                className={classNames(
                                    "clean-filters-label font-light p-absolute top-35 mt-0 pt-1 min-height-auto",
                                    { "top-25": !isDesktop },
                                    { "mr-3": isDesktop },
                                )}
                                onClick={cleanFilters}
                                image="images/cross.svg"
                                imageStyle="circle-cross"
                            />
                        )}
                    </Col>
                </Container>
                {showForm && (
                    <CedipFilters
                        isDesktop={isDesktop}
                        isSmallDesktop={isSmallDesktop}
                        values={values}
                        fetching={fetching}
                        recievedCedipSelected={recievedCedipSelected}
                        showForm={showForm}
                        handleChangeFilterOrder={handleChangeDirection}
                        handleChangeOrder={handleChangeOrderBy}
                        setCleanFilter={(val) => setCedipState({ ...cedipState, cleanFilter: val })}
                        {...cedipState}
                        cleanFilter={cedipState.cleanFilter}
                        handleSubmitFilters={handleSubmitFilters}
                        filters={ownCedipSelected ? filters : filtersReceived}
                        setValues={setValues}
                    />
                )}
                <div>
                    {cedips.length ? (
                        <>
                            {isDesktop ? (
                                <PageLoading loading={fetching} className="screen-loader">
                                    <Container className="align-items-center flex-grow">
                                        <div className="table table--products">
                                            <div
                                                role="menu"
                                                className={classNames("table-body", {
                                                    "table-body--grid": productAsCard,
                                                    "mt-5": !isDesktop,
                                                })}>
                                                {cedips && (
                                                    <>
                                                        {cedips.map((cedip) => (
                                                            <CedipCard
                                                                key={cedip.cedipId}
                                                                dispatch={dispatch}
                                                                cedip={cedip}
                                                                productAsCard={productAsCard}
                                                                isDesktop={isDesktop}
                                                                isSmallDesktop={isSmallDesktop}
                                                                openDrawer={() =>
                                                                    setCedipState({
                                                                        ...cedipState,
                                                                        showDrawer: true,
                                                                        cedipToAccept: cedip,
                                                                    })
                                                                }
                                                                ownCedipSelected={ownCedipSelected}
                                                            />
                                                        ))}
                                                        <div
                                                            className={`d-flex justify-content-end 
                                                                ${!enableNewPagination && "mr-3 my-3"}`}>
                                                            <Pagination
                                                                totalPages={cedipsTotalPages}
                                                                pageNumber={cedipsPageNumber}
                                                                action={getCedisNextPage}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </Container>
                                </PageLoading>
                            ) : (
                                <div className="mt-5">
                                    <InfiniteScroll
                                        dataLength={cedips.length}
                                        next={getCedisNextPage}
                                        hasMore={hasMoreData}
                                        loader={<Spinner />}
                                        endMessage={endOfListItem}
                                        scrollableTarget={
                                            isUxDashboardImprovementsEnabled() ? V3_SCROLL_ROOT_ID : undefined
                                        }>
                                        {cedips.map((cedip) => (
                                            <CedipCard
                                                key={cedip.cedipId}
                                                dispatch={dispatch}
                                                cedip={cedip}
                                                productAsCard={productAsCard}
                                                isDesktop={isDesktop}
                                                isSmallDesktop={isSmallDesktop}
                                                openDrawer={() =>
                                                    setCedipState({
                                                        ...cedipState,
                                                        showDrawer: true,
                                                        cedipToAccept: cedip,
                                                    })
                                                }
                                                ownCedipSelected={ownCedipSelected}
                                            />
                                        ))}
                                    </InfiniteScroll>
                                </div>
                            )}
                        </>
                    ) : (
                        <GeneralMsg
                            className="d-flex flex-column align-items-center mt-5"
                            imagePath="images/coloredIcons/find-in-page.svg"
                            description={i18n.get("deposits.list.empty")}
                            isDesktop={isDesktop}
                        />
                    )}
                </div>
            </div>
        </>
    );
}

CedipList.propTypes = {
    accounts: shape([]).isRequired,
    user: shape({
        userId: string.isRequired,
    }).isRequired,
    dispatch: func.isRequired,
    fetching: oneOfType([string, bool]),
    cedips: oneOfType([array]),
    values: shape({}).isRequired,
    isDesktop: bool.isRequired,
    isSmallDesktop: bool.isRequired,
    fetchingDownload: bool.isRequired,
    activeEnvironment: shape({}).isRequired,
    showForm: bool.isRequired,
    setValues: func.isRequired,
    setErrors: func.isRequired,
    recievedCedipSelected: bool.isRequired,
    ownCedipSelected: bool.isRequired,
    match: shape.isRequired,
    filters: shape({
        creationDate: bool.isRequired,
        createdFrom: string.isRequired,
        createdTo: string.isRequired,
        dueDate: bool.isRequired,
        dueDateFrom: string.isRequired,
        dueDateTo: string.isRequired,
        status: shape({ value: string.isRequired, label: string.isRequired }).isRequired,
        idCedip: string.isRequired,
        orderColumName: string.isRequired,
        orderDirection: string.isRequired,
    }).isRequired,
    filtersReceived: shape({}).isRequired,
    hasMoreData: bool,
    cedipsPageNumber: string.isRequired,
    cedipsTotalPages: string.isRequired,
    embeddedInV3Shell: bool,
};

CedipList.defaultProps = {
    fetching: false,
    hasMoreData: false,
    cedips: [],
    embeddedInV3Shell: false,
};

const mapStateToProps = (state) => ({
    accounts: accountsSelectors.getAccounts(state),
    user: sessionSelectors.getUser(state),
    cedips: cedipSelectors.getCedipList(state),
    cedipsPageNumber: cedipSelectors.getCedipListPageNumber(state),
    cedipsTotalPages: cedipSelectors.getCedipListTotalPages(state),
    fetching: cedipSelectors.getFetching(state),
    fetchingDownload: cedipSelectors.getFetchingDownload(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    ownCedipSelected: cedipSelectors.ownCedipSelected(state),
    recievedCedipSelected: cedipSelectors.recievedCedipSelected(state),
    showForm: cedipSelectors.getShowForm(state),
    filters: cedipSelectors.getFilters(state),
    setId: cedipSelectors.setId(state),
    filtersReceived: cedipSelectors.getFiltersReceived(state),
    hasMoreData: cedipSelectors.hasMoreData(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: ({ ownCedipSelected }) => ({
            status: ownCedipSelected ? "ACTIVO" : "ACTIVO-PENDIENTE",
            idCedip: "",
            creationDate: true,
            creationDateFrom: getLimitDate(-30),
            creationDateTo: getLimitDate(0),
            creationDates: [getLimitDate(-30).toDate(), getLimitDate(0).toDate()],
            dueDate: true,
            dueDateFrom: getLimitDate(0),
            dueDateTo: getLimitDate(30),
            dueDates: [getLimitDate(0).toDate(), getLimitDate(30).toDate()],
        }),
        validationSchema: () => {
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            return Yup.lazy((values) =>
                Yup.object().shape({
                    ...(!!enableRangeDatefield && {
                        dueDateFrom: values.dueDateTo
                            ? Yup.date()
                                  .nullable()
                                  .max(values.dueDateTo, i18n.get(`${FORM_ID}.dateFrom.error`))
                            : Yup.date().nullable(),
                        dueDateTo: values.dueDateFrom
                            ? Yup.date()
                                  .nullable()
                                  .min(values.dueDateFrom, i18n.get(`${FORM_ID}.dateTo.error`))
                            : Yup.date().nullable(),
                        creationDateFrom: values.creationDateTo
                            ? Yup.date()
                                  .nullable()
                                  .max(values.creationDateTo, i18n.get(`${FORM_ID}.dateFrom.error`))
                            : Yup.date().nullable(),
                        creationDateTo: values.creationDateFrom
                            ? Yup.date()
                                  .nullable()
                                  .min(values.creationDateFrom, i18n.get(`${FORM_ID}.dateTo.error`))
                            : Yup.date().nullable(),
                    }),
                }),
            );
        },
        handleSubmit: (formFilters, formikBag) => {
            const { dispatch, filters, filtersReceived, ownCedipSelected, isDesktop } = formikBag.props;
            const { pageNumber } = ownCedipSelected ? filters : filtersReceived;
            const { setValues } = formikBag;
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            const formattedDate = (d1, d2) => {
                const d = enableRangeDatefield ? d1 : d2.toString().replace(".000Z", "");
                return !d ? null : moment(d).format("YYYY-MM-DD");
            };

            const creationDateFrom = !formFilters.creationDates[1] ? null : formFilters.creationDates[0];

            const creationDateFromFormatted = formattedDate(creationDateFrom, formFilters.creationDateFrom);
            const creationDateToFormatted = formattedDate(formFilters.creationDates[1], formFilters.creationDateTo);
            const dueDateFromFormatted = formattedDate(formFilters.dueDates[0], formFilters.dueDateFrom);
            const dueDateToFormatted = formattedDate(formFilters.dueDates[1], formFilters.dueDateTo);

            if (enableRangeDatefield) {
                setValues({
                    ...formFilters,
                    ...(formFilters.creationDates.some((d) => !d) && {
                        creationDates: [null, null],
                    }),
                    ...(formFilters.dueDates.some((d) => !d) && {
                        dueDates: [null, null],
                    }),
                });
            }

            const filter = {
                ...formFilters,
                orderColumName: formFilters?.orderColumName,
                orderDirection: formFilters?.orderDirection,
                status: formFilters.status,
                pageNumber: pageNumber || 1,
                creationDateFrom: creationDateFromFormatted,
                creationDateTo: creationDateToFormatted,
                dueDateFrom: dueDateFromFormatted,
                dueDateTo: dueDateToFormatted,
                filterActivated: true,
                ...(enableRangeDatefield && {
                    creationDate: formFilters.creationDates.every((d) => d),
                    dueDate: formFilters.dueDates.every((d) => d),
                }),
            };
            if (ownCedipSelected) {
                dispatch(cedipActions.setFilters(filter));
            } else {
                dispatch(cedipActions.setFiltersReceived(filter));
            }
            dispatch(cedipActions.listCedip(filter, isDesktop, true));
        },
    }),
    resizableRoute,
)(CedipList);
